// extracted by mini-css-extract-plugin
export default {"container":"TabBarItem_container__FPFAv","titleText":"TabBarItem_titleText__Pfw5+","underLine":"TabBarItem_underLine__XYWIN"};